import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useApiClient, validateSuccess2xx } from '../../clients/apiAuth';

import { CustomToast, ErrorToast, OkToast } from '../../components/specific/Toast';
import ViewServicio from './ViewServicios';
import {
  setSelSolicitud,
  setSelSolicitudLog,
  setSolicitud,
  setSolicitudInit,
  setSelAsignarBono,
  setAsignarSelBonoInit,
  setTipoVehiculoInit,
  setSelTipoVehiculo,
  setSelTipoVehiculoInit,
} from '../../actions';
import { store } from '../../store';

import { CheckParameter } from '../../utils/security';

// import toast from 'react-hot-toast';

const Servicios = (props) => {
  const [nuevoServicio, setNuevoServicio] = useState(false);
  const [modaladdItmen, setModaladdItmen] = useState(false);
  const [modalInfoServicio, setModalInfoServicio] = useState(false);
  const [modalRechazarSolicitud, setModalRechazarSolicitud] = useState(false);
  const [modalManifiesto, setModalManifiesto] = useState(false);
  const [loadingTables, setLoadingTables] = useState(false);
  const [modalEjecucion, setModalEjecucion] = useState(false);
  const [modalLogs, setModalLogs] = useState(false);
  const [isModalEvaluacionVisible, setIsModalEvaluacionVisible] = useState(false);
  const [isModalNuevoAnticipoVisible, setIsModalNuevoAnticipoVisible] = useState(false);

  const [modalReporte, setModalReporte] = useState(false);
  const [modalConfirmar, setModalConfirmar] = useState(false);
  const [modalSeleccionarManifestoOReporte, setModalSeleccionarManifestoOReporte] = useState(false);

  const [isModalProducidoVisible, setIsModalProducidoVisible] = useState(false);
  const [producidoModalConfig, setProducidoModalConfig] = useState({ readOnly: false });

  const [idSolicitud, setIdSolicitud] = useState('');
  const [estadoAprobado, setEstadoAprobado] = useState(CheckParameter(props.auth?.data.selCliente.parametro, 'PARAMETRO_ID', 2) ? 0 : 1);
  const [solicitudResult, setSolicitudResult] = useState([]);
  const [solicitudEval, setSolicitudEval] = useState([]);

  const [vehiculoTipoOptions, setVehiculoTipoOptions] = useState([]);
  // const [vehiculoOptions, setVehiculoOptions] = useState([]);
  const [trailerOptions, setTrailerOptions] = useState([]);
  const [conductorOptions, setConductorOptions] = useState([]);

  const [aparejadorOptions, setAparejadorOptions] = useState([]);

  const [modalAsignarBono, setModalAsignarBono] = useState(false);
  const [bonoAsignado, setBonoAsignado] = useState([]);

  const [tipoSolicitud, setTipoSolicitud] = useState(1);

  const [isModalSiesaLogVisible, setIsModalSiesaLogVisible] = useState(false);
  const [siesaModalData, setSiesaModalData] = useState({});

  const handleShowSiesaLog = (row, isSendFail) => {
    console.log('handleShowSiesaLog: ', row, isSendFail);

    setSiesaModalData({
      row,
      isSendFail,
      isRNDC: false,
    });
    setIsModalSiesaLogVisible(true);
  };

  const handleShowSiesaLogRNDC = (row, isSendFail) => {
    console.log('handleShowSiesaLogRNDC: ', row, isSendFail);

    setSiesaModalData({
      row,
      isSendFail,
      isRNDC: true,
    });
    setIsModalSiesaLogVisible(true);
  };

  const selSolicitudVehiculoTipoID = props.tipoVehiculo.selTipoVehiculo?.SOLICITUD_VEHICULO_TIPO_ID;

  const { get, post, put } = useApiClient();

  const [currentPage, setCurrentPage] = useState(
    props.Solicitud.pagination === null || props.Solicitud.pagination === undefined ? 1 : props.Solicitud.pagination.currentPage
  );

  const handleNextPage = (page) => {
    console.log('page: ', page);
    const totalPages = props.Solicitud.pagination?.totalPages || 0;
    console.log('totalPages: ', totalPages);

    if (totalPages === 0) {
      setCurrentPage(1);
      return;
    }

    if (!page && currentPage === totalPages) return;

    setCurrentPage(page ? page : currentPage + 1);
    getSolicitud(estadoAprobado, page ? page : currentPage + 1);
  };
  const handlePreviusPage = () => {
    if (currentPage === 1) return;
    setCurrentPage(currentPage - 1);
    getSolicitud(estadoAprobado, currentPage - 1);
  };

  const [filterQuery, setFilterQuery] = useState('');

  const getSolicitud = async (estado = estadoAprobado, pageInd = currentPage, filter = filterQuery) => {
    setLoadingTables(true);
    try {
      const filterParam = filter ? `&QUERY=${filter}` : '';

      const result = await get(
        `/solicitud?page=${pageInd}&TERCERO_ID=${props.auth.data.user.TERCERO_ID}&SOLICITUD_APROBADA=${estado}&CLIENTE_ID=${props.auth.data.selCliente.TERCERO_ID}${filterParam}`
      );
      setLoadingTables(false);

      // if (!validateSuccess2xx(result)) return CustomToast({ result });
      if (!validateSuccess2xx(result)) {
        store.dispatch(setSolicitudInit(result));
        return;
      }

      store.dispatch(setSolicitud(result));
    } catch (error) {
      // console.log('Error:', error);
      ErrorToast('Error:', error);
    }
  };
  const getDocumentoPdf = async (item) => {
    try {
      const result = await get(`/documento?SOLICITUD_ID=${item.SOLICITUD_ID}&format=pdf`, 'application/pdf');

      if (result.type !== 'application/pdf') throw new Error('Documento no disponible...');

      const file = new Blob([result], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    } catch (error) {
      ErrorToast('Error:', error.message);
    }
  };
  const getDocumentoFinalPdf = async (item) => {
    try {
      const result = await get(`/documentoFinal?SOLICITUD_ID=${item.SOLICITUD_ID}&format=pdf`, 'application/pdf');

      if (result.type !== 'application/pdf') throw new Error('Documento no disponible...');

      const file = new Blob([result], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    } catch (error) {
      ErrorToast('Error:', error.message);
    }
  };

  const getTipoVehículo = async () => {
    try {
      const result = await get(`/vehiculoTipo`);

      if (!validateSuccess2xx(result)) return CustomToast({ result });

      const lst = result.data.map((row) => ({
        label: `${row.VEHICULO_TIPO_DESCRIPCION}`,
        value: row.VEHICULO_TIPO_ID,
      }));
      setVehiculoTipoOptions(lst);
    } catch (error) {
      ErrorToast('Error:', error);
    }
  };
  const getSolicitudEvaluacion = async () => {
    setSolicitudEval([]);
    try {
      const result = await get(`/solicitud/${props.Solicitud?.selSolicitud?.SOLICITUD_ID}}?EVAL=1`);

      if (!validateSuccess2xx(result)) return CustomToast({ result });

      setSolicitudEval(result.data);
    } catch (error) {
      ErrorToast('Error:', error);
    }
  };

  const getTrailer = async () => {
    const result = await get(`/trailer`);

    if (!validateSuccess2xx(result)) return CustomToast({ result });

    const lst = result.data.map((row) => ({
      label: `${row.VEHICULO_PLACA}`,
      value: row.VEHICULO_ID,
      propietario: row.TERCERO_PROPIETARIO_NOMBRE,
      tenedor: row.TERCERO_TENEDOR_NOMBRE,
      propio: row.VEHICULO_PROPIO,
    }));

    const withSelectNone = [
      {
        label: 'Ninguno',
        value: '',
      },
      ...lst,
    ];

    setTrailerOptions(withSelectNone);
  };

  const getConductor = async () => {
    const result = await get(`/tercero?ROL_ID=7`);

    if (!validateSuccess2xx(result)) return CustomToast({ result });

    const lst = result.data.map((row) => ({
      label: `${row.TERCERO_NOMBRE_BUSQUEDA}`,
      value: row.TERCERO_ID,
      isEmployee: row.ES_EMPLEADO,
    }));

    setConductorOptions(lst);
  };

  const getAparejador = async () => {
    const result = await get(`/tercero?ROL_ID=14`);

    if (!validateSuccess2xx(result)) return CustomToast({ result });

    const lst = result.data.map((row) => ({
      label: `${row.TERCERO_NOMBRE_BUSQUEDA}`,
      value: row.TERCERO_ID,
      isEmployee: row.ES_EMPLEADO,
    }));

    const withSelectNone = [
      {
        label: 'Ninguno',
        value: '',
      },
      ...lst,
    ];

    setAparejadorOptions(withSelectNone);
  };

  const postEvaluacion = async (form) => {
    // console.log('form: ', form);
    // return;
    try {
      const result = await put(
        `/solicitud/${props.Solicitud?.selSolicitud?.SOLICITUD_ID}?EDITAR_SOLO_EVAL=1`,
        {
          json: JSON.stringify({
            EV_LOGISTICA: form.EV_LOGISTICA,
            EV_INCIDENTES_PERSONALES: form.EV_INCIDENTES_PERSONALES,
            EV_TIEMPO_RESPUESTA: form.EV_TIEMPO_RESPUESTA,
            EV_INCIDENTES_VEHICULARES: form.EV_INCIDENTES_VEHICULARES,
            EV_DESEMPENO_HSEQ: form.EV_DESEMPENO_HSEQ,
            EV_INCIDENTES_AMBIENTALES: form.EV_INCIDENTES_AMBIENTALES,
            EV_SOLUCION_DESVIACIONES: form.EV_SOLUCION_DESVIACIONES,
            EV_INCIDENTES_CARGA: form.EV_INCIDENTES_CARGA,
            EV_CALIDAD_SERVICIO: form.EV_CALIDAD_SERVICIO,
            EV_AFECTACION_PATRIMONIO: form.EV_AFECTACION_PATRIMONIO,
            EV_AFECTACION_COMUNIDAD: form.EV_AFECTACION_COMUNIDAD,
            EV_AFECTACION_IMAGEN: form.EV_AFECTACION_IMAGEN,
            EV_EVALUADOR: form.EV_EVALUADOR,
          }),
        },
        'application/json'
      );
      if (String(result.status).substr(0, 1) !== '2') {
        CustomToast({ result });
      } else {
        OkToast({ result, message: 'Evaluacion enviada...' });
        getSolicitud();
        setIsModalEvaluacionVisible(false);
      }
    } catch (error) {
      ErrorToast('Error:', error);
    }
  };

  const createServicio = async (form) => {
    try {
      const result = await post(
        '/solicitud',
        {
          json: JSON.stringify(form),
        },
        'application/json'
      );

      if (String(result.status).substr(0, 1) !== '2') {
        CustomToast({ result });
      } else {
        //getServicios();
        setNuevoServicio(false);
        getSolicitud();
        OkToast({ result, message: 'Servicio Agregado!' });
      }
    } catch (error) {
      ErrorToast('Error:', error);
    }
  };

  const createManifiesto = async (form) => {
    try {
      const result = await post(
        '/selSolicitudVehiculoTipoID',
        {
          json: JSON.stringify({
            TIPO: '1',
            SOLICITUD_VEHICULO_TIPO_ID: selSolicitudVehiculoTipoID,
            SOLICITUD_PESO: form.SOLICITUD_PESO,
            //VEHICULO_ID: form.TRAILER_ID,
            //CONDUCTOR_TERCERO_ID: form.CONDUCTOR_TERCERO_ID,
            CONDUCTOR_VALOR: form.CONDUCTOR_VALOR,
            CONDUCTOR_ANTICIPO: form.CONDUCTOR_ANTICIPO,
            //SOLICITUD_VEHICULO_TOTAL: form.CONDUCTOR_VALOR,
          }),
        },
        'application/json'
      );

      if (!validateSuccess2xx(result)) return CustomToast({ result });

      //getServicios();
      setNuevoServicio(false);
      getSolicitud();
      OkToast({ result, message: 'Manifiesto Agregado!' });
    } catch (error) {
      ErrorToast('Error:', error);
    }
  };
  const createReporte = async (form) => {
    try {
      const result = await post(
        `/solicitudVehiculoTipo/${form.SOLICITUD_VEHICULO_TIPO_ID}/generarReporte`,
        {
          json: JSON.stringify({
            SOLICITUD_VEHICULO_TIPO_ID: form.SOLICITUD_VEHICULO_TIPO_ID,
            //SOLICITUD_PESO: form.SOLICITUD_PESO,
            // VEHICULO_ID: form.TRAILER_ID,
            // CONDUCTOR_TERCERO_ID: form.CONDUCTOR_TERCERO_ID,
            TERCERO_AUDITORIA: form.TERCERO_AUDITORIA,
            CONDUCTOR_VALOR: form.CONDUCTOR_VALOR,
            CONDUCTOR_ANTICIPO: form.CONDUCTOR_ANTICIPO,
            CONDUCTOR_BENEFICIARIO_ID: form.CONDUCTOR_BENEFICIARIO_ID,
            CONDUCTOR_BENEFICIARIO_TIPO: form.CONDUCTOR_BENEFICIARIO_TIPO,
            CONDUCTOR_BENEFICIARIO_ES_TERCERO: form.CONDUCTOR_BENEFICIARIO_ES_TERCERO,
            CONDUCTOR_BENEFICIARIO_NOMBRE: form.CONDUCTOR_BENEFICIARIO_NOMBRE,
            CONDUCTOR_BENEFICIARIO_DOCUMENTO: form.CONDUCTOR_BENEFICIARIO_DOCUMENTO,

            APAREJADOR_VALOR: form.APAREJADOR_VALOR,
            APAREJADOR_ANTICIPO: form.APAREJADOR_ANTICIPO,

            SOLICITUD_VEHICULO_P1: form.SOLICITUD_VEHICULO_P1,
            SOLICITUD_VEHICULO_P2: form.SOLICITUD_VEHICULO_P2,
            SOLICITUD_VEHICULO_P3: form.SOLICITUD_VEHICULO_P3,
            SOLICITUD_VEHICULO_P4: form.SOLICITUD_VEHICULO_P4,
            SOLICITUD_ID: form.SOLICITUD_ID,

            // SOLICITUD_VEHICULO_TOTAL: form.CONDUCTOR_VALOR,
          }),
        },
        'application/json'
      );

      if (!validateSuccess2xx(result)) return CustomToast({ result });

      //getServicios();
      setNuevoServicio(false);
      getSolicitud();
      OkToast({ result, message: 'Reporte Generado!' });
      setModalReporte(false);
    } catch (error) {
      ErrorToast('Error:', error);
    }
  };
  const createNuevoAnticipo = async (form) => {
    console.log('*** createNuevoAnticipo: ', form);
    // return;
    try {
      const result = await post(
        `/solicitudVehiculoTipo/${form.SOLICITUD_VEHICULO_TIPO_ID}/nuevoAnticipo`,
        // `/test/nuevoAnticipo/${form.SOLICITUD_VEHICULO_TIPO_ID}`,
        {
          json: JSON.stringify({
            SOLICITUD_VEHICULO_TIPO_ID: form.SOLICITUD_VEHICULO_TIPO_ID,
            //SOLICITUD_PESO: form.SOLICITUD_PESO,
            // VEHICULO_ID: form.TRAILER_ID,
            // CONDUCTOR_TERCERO_ID: form.CONDUCTOR_TERCERO_ID,
            TERCERO_AUDITORIA: form.TERCERO_AUDITORIA,
            CONDUCTOR_VALOR: form.CONDUCTOR_VALOR,
            CONDUCTOR_ANTICIPO: form.CONDUCTOR_ANTICIPO,
            // CONDUCTOR_BENEFICIARIO_ID: form.CONDUCTOR_BENEFICIARIO_ID,
            // CONDUCTOR_BENEFICIARIO_TIPO: form.CONDUCTOR_BENEFICIARIO_TIPO,
            // CONDUCTOR_BENEFICIARIO_ES_TERCERO: form.CONDUCTOR_BENEFICIARIO_ES_TERCERO,
            // CONDUCTOR_BENEFICIARIO_NOMBRE: form.CONDUCTOR_BENEFICIARIO_NOMBRE,
            // CONDUCTOR_BENEFICIARIO_DOCUMENTO: form.CONDUCTOR_BENEFICIARIO_DOCUMENTO,

            PROVEEDOR_TERCERO_ID: form.PROVEEDOR_TERCERO_ID || '',

            APAREJADOR_VALOR: form.APAREJADOR_VALOR,
            APAREJADOR_ANTICIPO: form.APAREJADOR_ANTICIPO,

            SOLICITUD_VEHICULO_P1: form.SOLICITUD_VEHICULO_P1,
            SOLICITUD_VEHICULO_P2: form.SOLICITUD_VEHICULO_P2,
            SOLICITUD_VEHICULO_P3: form.SOLICITUD_VEHICULO_P3,
            SOLICITUD_VEHICULO_P4: form.SOLICITUD_VEHICULO_P4,
            SOLICITUD_ID: form.SOLICITUD_ID,

            CONDUCTOR_VALOR_NOTA: form.CONDUCTOR_VALOR_NOTA,
            APAREJADOR_VALOR_NOTA: form.APAREJADOR_VALOR_NOTA,

            // SOLICITUD_VEHICULO_TOTAL: form.CONDUCTOR_VALOR,
          }),
        },
        'application/json'
      );

      if (!validateSuccess2xx(result)) return CustomToast({ result });

      //getServicios();

      getSolicitud();
      OkToast({ result, message: 'Solicitud de Anticipo Generada!' });
      setIsModalNuevoAnticipoVisible(false);
    } catch (error) {
      ErrorToast('Error:', error);
    }
  };
  const confirmarSolicitud = async (form) => {
    try {
      const result = await post(
        `/solicitudVehiculoTipo/${form.SOLICITUD_VEHICULO_TIPO_ID}/confirmar`,
        {
          json: JSON.stringify({
            TIPO: '3',
            SOLICITUD_VEHICULO_TIPO_ID: form.SOLICITUD_VEHICULO_TIPO_ID,
            SOLICITUD_PESO: form.SOLICITUD_PESO,
            VEHICULO_ID: form.VEHICULO_ID,
            CONDUCTOR_TERCERO_ID: form.CONDUCTOR_TERCERO_ID,
            TRAILER_ID: form.TRAILER_ID,
            PROVEEDOR_TERCERO_ID: '',
            APAREJADOR_TERCERO_ID: form.APAREJADOR_TERCERO_ID,
            SOLICITUD_ID: form.SOLICITUD_ID,
          }),
        },
        'application/json'
      );

      if (!validateSuccess2xx(result)) return CustomToast({ result });

      //getServicios();

      setNuevoServicio(false);
      getSolicitud();
      OkToast({ result, message: 'Vehículo confirmado!' });

      setModalConfirmar(false);
    } catch (error) {
      ErrorToast('Error:', error);
    }
  };
  const sinAnticipo = async (form) => {
    try {
      const result = await post(
        `/solicitud/${form.SOLICITUD_ID}/noAnticipo`,
        {
          json: JSON.stringify({
            TERCERO_ID: props.auth.data.user.TERCERO_ID,
          }),
        },
        'application/json'
      );

      if (!validateSuccess2xx(result)) return CustomToast({ result });

      //getServicios();

      getSolicitud();
      OkToast({ result, message: 'Solicitud sin anticipo!' });
    } catch (error) {
      ErrorToast('Error:', error);
    }
  };
  const messageAprobarSolicitud = (state) => {
    switch (state) {
      case 1:
        return 'Solicitud Aprobada';
      case 2:
        return 'Solicitud Rechazada!';
      case 6:
        return 'Solicitud Finalizada!';
      default:
        return 'Solicitud en ejecución';
    }
  };
  const aprobarSolicitud = async (id, estado, obs = '') => {
    try {
      const result = await put(
        `/solicitud/${id}?EDITAR_SOLO_APROBAR=1`,
        {
          json: JSON.stringify({
            SOLICITUD_APROBADA: `${estado}`,
            SOLICITUD_APROBADA_OBS: `${obs}`,
            TERCERO_ID: auth.data.user.TERCERO_ID,
          }),
        },
        'application/json'
      );

      if (String(result.status).substr(0, 1) !== '2') {
        CustomToast({ result });
      } else {
        getSolicitud();
        OkToast({
          result,
          message: messageAprobarSolicitud(estado),
        });
      }
    } catch (error) {
      ErrorToast('Error:', error);
    }
  };

  const resendSiesaFD = async (solicitudID) => {
    try {
      const result = await post(
        `/siesa/${solicitudID}/fd`,
        {
          json: JSON.stringify({
            TERCERO_ID: props.auth.data.user.TERCERO_ID,
          }),
        },
        'application/json'
      );

      if (!validateSuccess2xx(result)) return CustomToast({ result });

      //getServicios();
      getSolicitud();

      OkToast({ result, message: 'Enviado...' });
    } catch (error) {
      ErrorToast('Error:', error);
    }
  };
  const resendSiesaRNDC = async (solicitudID) => {
    try {
      const result = await post(
        `/siesa/${solicitudID}/rndc`,
        {
          json: JSON.stringify({
            TERCERO_ID: props.auth.data.user.TERCERO_ID,
          }),
        },
        'application/json'
      );

      if (!validateSuccess2xx(result)) return CustomToast({ result });

      //getServicios();
      getSolicitud();

      OkToast({ result, message: 'Enviado...' });
    } catch (error) {
      ErrorToast('Error:', error);
    }
  };

  const finalizarSolicitud = async (id, estado, obs = '') => {
    try {
      const result = await put(
        `/solicitud/${id}?EDITAR_SOLO_FINALIZAR=1`,
        {
          json: JSON.stringify({ SOLICITUD_APROBADA: `${estado}`, TERCERO_ID: auth.data.user.TERCERO_ID }),
        },
        'application/json'
      );

      if (String(result.status).substr(0, 1) !== '2') {
        CustomToast({ result });
      } else {
        OkToast({
          result,
          message: messageAprobarSolicitud(estado),
        });
      }
    } catch (error) {
      ErrorToast('Error:', error);
    }
    getSolicitud();
  };

  const notificarManifiesto = async (form) => {
    try {
      const result = await post(
        `/solicitudVehiculoTipo/${form.SOLICITUD_VEHICULO_TIPO_ID}/notificarManifiesto`,
        {
          json: JSON.stringify(form),
        },
        'application/json'
      );

      if (!validateSuccess2xx(result)) return CustomToast({ result });

      //getServicios();
      setNuevoServicio(false);
      getSolicitud();
      OkToast({ result, message: 'Manifiesto guardado!' });
      setModalManifiesto(false);
    } catch (error) {
      ErrorToast('Error:', error);
    }
  };

  const handlePorAprobar = () => {
    setLoadingTables(true);
    store.dispatch(setSolicitudInit());
    store.dispatch(setTipoVehiculoInit());
    setCurrentPage(1);
    setEstadoAprobado(0);
  };

  const handleAprobado = () => {
    setLoadingTables(true);
    store.dispatch(setSolicitudInit());
    store.dispatch(setTipoVehiculoInit());
    setCurrentPage(1);
    setEstadoAprobado(1);
  };

  const handleCancelado = () => {
    setLoadingTables(true);
    store.dispatch(setSolicitudInit());
    store.dispatch(setTipoVehiculoInit());
    setCurrentPage(1);
    setEstadoAprobado(2);
  };

  const handleRechazado = () => {
    setLoadingTables(true);
    store.dispatch(setSolicitudInit());
    store.dispatch(setTipoVehiculoInit());
    setCurrentPage(1);
    setEstadoAprobado(3);
  };

  const handleConfirmadas = () => {
    setLoadingTables(true);
    store.dispatch(setSolicitudInit());
    store.dispatch(setTipoVehiculoInit());
    setCurrentPage(1);
    setEstadoAprobado(4);
  };

  const handleEjecucion = () => {
    setLoadingTables(true);
    store.dispatch(setSolicitudInit());
    store.dispatch(setTipoVehiculoInit());
    setCurrentPage(1);
    setEstadoAprobado(5);
  };

  const handleFinalizadas = () => {
    setLoadingTables(true);
    store.dispatch(setSolicitudInit());
    store.dispatch(setTipoVehiculoInit());
    setCurrentPage(1);
    setEstadoAprobado(6);
  };

  const getServicioLogs = async (solicitud) => {
    try {
      const result = await get(`/solicitudLog/${solicitud.SOLICITUD_ID}`);

      if (!validateSuccess2xx(result)) return CustomToast({ result });

      store.dispatch(setSelSolicitudLog(result.data));
    } catch (error) {
      ErrorToast('Error:', error);
    }
  };

  const handleReject = (id) => {
    setIdSolicitud(id);
    setModalRechazarSolicitud(true);
  };

  const handleOpenProducido = (solicitudData) => {
    store.dispatch(setSelSolicitud(solicitudData));
    const vehiculos = solicitudData?.solicitud_vehiculo_tipo || [];
    if (vehiculos.length > 0) {
      store.dispatch(setSelTipoVehiculo(vehiculos[0]));
    } else {
      store.dispatch(setSelTipoVehiculoInit());
    }
    setProducidoModalConfig({
      readOnly: Number(solicitudData.PR_ESTADO) === 1,
    });
    setIsModalProducidoVisible(true);
  };

  const saveProducido = async ({ solicitudId, nota }) => {
    if (!solicitudId) {
      ErrorToast('Error:', 'Solicitud no válida');
      return;
    }

    try {
      const result = await post(
        `/solicitud/${solicitudId}/producido`,
        {
          json: JSON.stringify({
            PR_NOTA: nota,
            PR_ESTADO: 1,
            PR_USUARIO: props.auth.data.user.TERCERO_ID,
          }),
        },
        'application/json'
      );

      if (!validateSuccess2xx(result)) return CustomToast({ result });

      OkToast({ result, message: 'Nota de producido registrada!' });
      setIsModalProducidoVisible(false);
      getSolicitud();
    } catch (error) {
      ErrorToast('Error:', error);
    }
  };

  const handleEdit = (obj) => {
    store.dispatch(setSelSolicitud(obj));

    setNuevoServicio(true);
  };

  function handleEditBonoAsignado(obj) {
    store.dispatch(setSelAsignarBono(obj));
    setModalAsignarBono(true);
  }

  useEffect(() => {
    getTipoVehículo();
    getTrailer();
    getConductor();
    getAparejador();
  }, []);

  useEffect(() => {
    getSolicitud();
  }, [estadoAprobado]);

  const handleFilterQuery = (query, allClients) => {
    console.log('allClients: ', allClients);
    setFilterQuery(query);
    getSolicitud(estadoAprobado, 1, query);

    // getSolicitud(1, query, allClients);
  };

  const solicitud = props.Solicitud;
  const auth = props.auth;

  return (
    <ViewServicio
      endPoint={{
        createServicio,
        solicitudResult,
        aprobarSolicitud,
        finalizarSolicitud,
        createManifiesto,
        confirmarSolicitud,
        createReporte,
        getServicioLogs,
        postEvaluacion,
        notificarManifiesto,
        getDocumentoPdf,
        getDocumentoFinalPdf,
        resendSiesaFD,
        resendSiesaRNDC,
        sinAnticipo,
        createNuevoAnticipo,
        getSolicitudEvaluacion,
        saveProducido,
      }}
      modales={{
        setNuevoServicio,
        nuevoServicio,
        modaladdItmen,
        setModaladdItmen,
        modalInfoServicio,
        setModalInfoServicio,
        modalRechazarSolicitud,
        setModalRechazarSolicitud,
        modalSeleccionarManifestoOReporte,
        setModalSeleccionarManifestoOReporte,
        modalManifiesto,
        setModalManifiesto,
        modalReporte,
        setModalReporte,
        modalConfirmar,
        setModalConfirmar,
        modalEjecucion,
        setModalEjecucion,
        modalLogs,
        setModalLogs,
        isModalEvaluacionVisible,
        setIsModalEvaluacionVisible,
        modalAsignarBono,
        setModalAsignarBono,
        isModalNuevoAnticipoVisible,
        setIsModalNuevoAnticipoVisible,
        isModalSiesaLogVisible,
        setIsModalSiesaLogVisible,
        isModalProducidoVisible,
        setIsModalProducidoVisible,
      }}
      data={{
        idSolicitud,
        vehiculoTipoOptions,
        trailerOptions,
        conductorOptions,
        aparejadorOptions,
        solicitud,
        auth,
        bonoAsignado,
        tipoSolicitud,
        siesaModalData,
        solicitudEval,
        producidoModalConfig,
      }}
      actions={{
        handleAprobado,
        handlePorAprobar,
        handleCancelado,
        handleRechazado,
        estadoAprobado,
        handleEdit,
        handleReject,
        loadingTables,
        handleConfirmadas,
        handleEjecucion,
        handleFinalizadas,
        handleEditBonoAsignado,
        setBonoAsignado,
        setTipoSolicitud,
        handleShowSiesaLog,
        handleShowSiesaLogRNDC,
        handleFilterQuery,
        handleOpenProducido,
      }}
      pager={{ handleNextPage, handlePreviusPage }}
    />
  );
};

const mapStateToProps = function (state) {
  return {
    auth: state.auth,
    tipoVehiculo: state.tipoVehiculo,
    Solicitud: state.Solicitud,
  };
};

export default connect(mapStateToProps)(Servicios);
